import { Spacing } from '@squareup/dex-ui-shared-base';
import { cardLayout } from '@squareup/dex-ui-shared-markdown-card';
import React, { FC, PropsWithChildren } from 'react';

interface MdxCardLayoutProps {
  direction?: 'row' | 'col';
  justify?: 'space-between' | 'space-evenly' | 'start' | 'end';
  spaceAbove?: Spacing;
  wrap?: boolean;
  type?: 'grid' | 'flex';
  disableCardLink?: boolean;
}

const CardLayoutComponent = cardLayout.component.value as FC<
  PropsWithChildren<MdxCardLayoutProps>
>;

const MdxCardLayout: FC<PropsWithChildren<MdxCardLayoutProps>> = ({
  children,
  ...props
}) => {
  return <CardLayoutComponent {...props}>{children}</CardLayoutComponent>;
};

MdxCardLayout.displayName = 'MdxCardLayout';

export { MdxCardLayout };
